import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

interface CustomButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'outlined' | 'text';
  loading?: boolean;
}

export const Button = ({
  children,
  variant = 'primary',
  loading = false,
  disabled,
  ...props
}: CustomButtonProps) => {
  let muiVariant: 'contained' | 'outlined' | 'text' = 'contained';
  
  if (variant === 'outlined') {
    muiVariant = 'outlined';
  } else if (variant === 'text') {
    muiVariant = 'text';
  }

  const customSx = {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 1,
    px: 3,
    py: 1.5,
    ...(variant === 'primary' && {
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
      color: 'white',
      '&:hover': {
        background: 'linear-gradient(45deg, #1976D2 30%, #1BA8D9 90%)',
      },
    }),
    ...(variant === 'secondary' && {
      backgroundColor: 'grey.100',
      color: 'text.primary',
      '&:hover': {
        backgroundColor: 'grey.200',
      },
    }),
  };

  return (
    <MuiButton
      variant={muiVariant}
      disabled={disabled || loading}
      sx={customSx}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </MuiButton>
  );
}; 